import { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import ContentHeader from '../../../../Layout/ContentHeader'
import LayoutTable from '../../../../Global/LayoutTable'
import { useParams, Link, useHistory } from 'react-router-dom'
import ModalContent from '../../../../Global/ModalContent'
import {
  DELETE_FORM_FIELD,
  GET_ALL_FORM_FIELDS_BY_FORM_ID,
} from '../../../../../graphql/Catalog/Forms/formFields'
import FormFieldYupRules from './FormFieldYupRules'
import { global_actionBtnDelete } from '../../../../Helpers/GenericFunctions'

const idModal = 'modalFormFields'
const formSelected = JSON.parse(sessionStorage.getItem('formSelected'))

export const FormFields = () => {
  const { formId } = useParams()
  const history = useHistory()

  //STATES
  const [dataTable, setDataTable] = useState([])
  const [total, setTotal] = useState(0)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 30,
    offset: 0,
  })
  const [modalContent, setModalContent] = useState({
    title: '',
    content: null,
  })

  //USEQUERY
  const { loading, data, error, refetch } = useQuery(
    GET_ALL_FORM_FIELDS_BY_FORM_ID,
    {
      variables: { ...pagePagination, formId: parseInt(formId) },
      fetchPolicy: 'no-cache',
    }
  )

  const [deleteForm] = useMutation(DELETE_FORM_FIELD)

  const showModal = async ({ type, item }) => {
    try {
      if (type === 'detailRules') {
        setModalContent({
          title: `Reglas de validacion para el campo "${item?.name}"`,
          content: (
            <FormFieldYupRules fieldData={item} refetchMain={() => refetch()} />
          ),
        })
      }
    } catch (error) {
      console.log({ error })
    }
  }

  const handleCloseModal = () => {
    setModalContent({ title: null, content: null })
    refetch()
  }

  //EFFECTS:
  useEffect(() => {
    try {
      if (loading) return
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      const datalist = data?.getAllFormFieldsByFormId?.rows.map((item) => {
        return {
          id: item.id,
          orden: item?.order,
          etiqueta: item?.label ?? '----',
          nombre: item?.name ?? '----',
          'Marcador de posición': item?.placeholder ?? '----',
          tipo: item.TypeOfField.description,
          'reglas de validación': (
            <button
              type="button"
              className="btn btn-migrates"
              data-toggle="modal"
              data-target={`#${idModal}`}
              onClick={(e) =>
                showModal({ type: 'detailRules', item: { ...item } })
              }
            >
              <i className="fab fa-wpforms"></i> (
              {item.FieldYupRulesOfFormField?.length ?? 0})
            </button>
          ),
          'Acciones': (
            <>
              <button
                type="button"
                title='Editar campo'
                className="btn btn-orange"                
                onClick={(e) =>
                  history.push(`/catalog/forms/${formId}/fields/edit/${item.id}`)
                }
              >
                <i class='fas fa-edit'></i>
              </button>
              <button
                type="button"
                title='Eliminar campo'
                className="btn btn-orange ml-1"
                onClick={(e) =>
                  global_actionBtnDelete(async () => { 
                    await deleteForm({
                      variables: { id: item.id },
                    })
                    refetch()
                    
                  })
                }
              >
                <i class='fas fa-trash'></i>
              </button>
            </>
          ),
        }
      })

      setDataTable(datalist)
      setTotal(data?.getAllTariffRulesGroupByPlatformId?.count)
    } catch (error) {
      console.log(error)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, data, error, refetch])

  return (
    <>
      <ContentHeader
        title=""
        breadcrumb="custom"
        titleContent={
          <div className="col-12 col-sm-6">
            <Link
              className="btn btn-migrates-white"
              to={`/catalog/forms`}
            >
              <i className="fas fa-long-arrow-alt-left" /> Atrás
            </Link>
          </div>
        }
        breadcrumbContent={
          <div className="col-12 col-sm-6">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item">
                <Link to={`/catalog/forms`}>Lista Formulario / </Link>
              </li>
              <li className="breadcrumb-iteem active">{` `}Campos</li>
            </ol>
          </div>
        }
        windowTitle="Campos del formulario"
      />

      <LayoutTable
        title={`Lista de campos del formulario ${formSelected?.name ? `"${formSelected.name}"` : ''}`}
        hideId
        data={dataTable}
        //gql={DELETE_FORM_FIELD}
        //requery={null}
        //refetchFunctionQueries={() => refetch()}
        exportImportButton={false}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        FilterBarPlaceholder="Buscar por etiqueta o nombre"
        hideActions={ true}
        showAddNewButton={true}
        handleAddNewButtonTxt='Agregar campo'
        handleAddNewButton={() => { history.push(`/catalog/forms/${formId}/fields/new`) }}
        // handleButton={(id) => { history.push(`/catalog/forms/${formId}/fields/edit/${id}`) }}
        // handleButtonTitle={<i class='fas fa-edit'></i>}
        // hideBtnDelete={false}        
        
      />

      <span
        id={`spanModal${idModal}`}
        className="btn invisible"
        data-toggle="modal"
        data-target={'#' + idModal}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
      />

      <ModalContent
        idModal={idModal}
        title={modalContent.title}
        size="extra"
        onClose={() => handleCloseModal()}
        content={modalContent.content}
      />
    </>
  )
}

export default FormFields
